import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import toast from 'react-hot-toast';
import Navbar from '../Navbar/Navbar';
import Footer from '../Footer/Footer';

function EditPodcastEpisode() {
    const { id } = useParams();
    const navigate = useNavigate();
    const [episode, setEpisode] = useState({
        episodeNumber: '',
        title: '',
        content: '',
        order: '',
        audioLink: '',
        timingLink: ''
    });
    const [podcastId, setPodcastId] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchEpisode = async () => {
            try {
                const response = await axios.get(`${process.env.REACT_APP_API_URL}/podcast-episode/${id}`);
                const data = response.data;
                setEpisode({
                    episodeNumber: data.episodeNumber || '',
                    title: data.title || '',
                    content: data.content || '',
                    order: data.order || '',
                    audioLink: data.audioLink || '',
                    timingLink: data.timingLink || ''
                });
                setPodcastId(data.podcastId);
            } catch (error) {
                console.error("Error fetching episode:", error);
                toast.error("خطا در دریافت اطلاعات قسمت");
            } finally {
                setLoading(false);
            }
        };
        fetchEpisode();
    }, [id]);

    const handleChange = (e) => {
        setEpisode({ ...episode, [e.target.name]: e.target.value });
    };

    const handleUpdate = async (e) => {
        e.preventDefault();
        try {
            const response = await axios.put(`${process.env.REACT_APP_API_URL}/podcast-episode/${id}`, {
                title: episode.title,
                content: episode.content,
                audioLink: episode.audioLink || null,
                timingLink: episode.timingLink || null
            });
            if (response.data.success) {
                toast.success("قسمت با موفقیت ویرایش شد!");
                navigate(`/podcast/${podcastId}`);
            } else {
                toast.error(response.data.message);
            }
        } catch (error) {
            console.error("Update error:", error);
            toast.error("خطا در ویرایش قسمت");
        }
    };

    if (loading) {
        return (
            <>
                <Navbar />
                <div className="container mt-5">
                    <div className="text-center py-5">
                        <div className="spinner-border text-primary" role="status">
                            <span className="visually-hidden">Loading...</span>
                        </div>
                        <p className="mt-3">در حال بارگذاری...</p>
                    </div>
                </div>
                <Footer />
            </>
        );
    }

    return (
        <>
            <Navbar />
            <div className="container mt-5 mb-5">
                <div className="row justify-content-center">
                    <div className="col-md-8">
                        <div className="card shadow">
                            <div className="card-header bg-warning">
                                <h3 className="mb-0">✏️ ویرایش قسمت {episode.episodeNumber}</h3>
                            </div>
                            <div className="card-body">
                                <form onSubmit={handleUpdate}>
                                    <div className="mb-3">
                                        <label className="form-label">شماره قسمت</label>
                                        <input 
                                            type="number" 
                                            className="form-control" 
                                            value={episode.episodeNumber} 
                                            disabled 
                                        />
                                        <small className="text-muted">شماره قسمت قابل ویرایش نیست</small>
                                    </div>

                                    <div className="mb-3">
                                        <label className="form-label">عنوان قسمت</label>
                                        <input 
                                            type="text" 
                                            className="form-control" 
                                            name="title" 
                                            value={episode.title} 
                                            onChange={handleChange} 
                                            placeholder="عنوان قسمت..." 
                                        />
                                    </div>

                                    <div className="mb-3">
                                        <label className="form-label">متن قسمت</label>
                                        <textarea 
                                            className="form-control" 
                                            name="content" 
                                            value={episode.content} 
                                            onChange={handleChange} 
                                            rows="5"
                                            placeholder="متن قسمت را وارد کنید..."
                                        />
                                    </div>

                                    <div className="mb-3">
                                        <label className="form-label">🎵 لینک فایل صوتی</label>
                                        <input 
                                            type="url" 
                                            className="form-control" 
                                            name="audioLink" 
                                            value={episode.audioLink} 
                                            onChange={handleChange} 
                                            placeholder="https://example.com/audio.mp3" 
                                        />
                                    </div>

                                    <div className="d-flex justify-content-between">
                                        <button type="submit" className="btn btn-warning">💾 ذخیره تغییرات</button>
                                        <button type="button" className="btn btn-secondary" onClick={() => navigate(`/podcast/${podcastId}`)}>انصراف</button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    );
}

export default EditPodcastEpisode;